import React from "react";
import styles from "./search-container.module.scss";

interface SearchContainerProps {
  title: string;
  value: string;
  onChange: (value: string) => void;
}

const SearchContainer: React.FC<SearchContainerProps> = ({ title, value, onChange }) => {
  return (
    <div className={styles.searchContainer}>
      <h4>{title}</h4>
      <div className={styles.searchBox}>
        <div className={styles.inputWrapper}>
          <input
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder=""
            aria-label="Search input"
          />
        </div>

        <button
          type="button"
          className={`${styles.searchButton} my-button`}
          aria-label="Search"
        >
          <div className={styles.iconWrapper}>
            <img
              alt=""
              src="/images/settings-v2/search-icon.svg"
              width={"14px"}
              height={"14px"}
            />
          </div>
        </button>
      </div>
    </div>
  );
};

export default SearchContainer;

